export default {"src":"/_next/static/image/public/images/no_vouchers.ace485f85f30dad80dbb8a7de98337dc.svg","height":151,"width":147};